export default {"src":"/_next/static/media/linkedin.005b4f5c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};